import { InjectionToken } from '@angular/core';
import { AnalyticsService, AnalyticsValueAllowlist, LocalizationService } from '@imagise/shared';

export interface ResolvedAnalyticsPage {
  readonly key: string;
  readonly path: string;
}

export function normalizeAnalyticsPagePath(url: string): string {
  return (url.split(/[?#]/, 1)[0] || '/').replace(/;[^/]*/g, '');
}

export interface AnalyticsTrackingConfig {
  resolvePage(url: string): ResolvedAnalyticsPage | null;
  buildAllowlist(localization: LocalizationService): AnalyticsValueAllowlist;
  contentLanguage(page: ResolvedAnalyticsPage, localization: LocalizationService): string;
  trackPageExtras?(
    analytics: AnalyticsService,
    page: ResolvedAnalyticsPage,
    localization: LocalizationService
  ): void;
}

export const ANALYTICS_TRACKING_CONFIG = new InjectionToken<AnalyticsTrackingConfig>(
  'ANALYTICS_TRACKING_CONFIG'
);
